<template>
  <div>
    <div class="flex gap-6 w-full overflow-y-auto">
      <div class="card-style bg-white dark:bg-slate-900">
        <div class="card-style-text">Total Revenue</div>
        <div class="card-style-price" v-tooltip.bottom-end="payments.total_amount">
          ₹{{ truncateAmount(payments.total_amount) }}
        </div>
      </div>
      <div
        class="card-style flex flex-col justify-between bg-white dark:bg-slate-900"
        v-for="(item, index) in payments.total_by_status"
        :key="index"
      >
        <div class="card-style-text">{{ item.status }}</div>
        <div class="card-style-price" 
        v-tooltip.bottom-end="item.amount">
          ₹{{ truncateAmount(item.amount) }}
        </div>
      </div>
    </div>
    <div>
      <transaction-sheet :payments="payments" @download_csv="downloadCSV" :selectedFilters="selectedFilters" :selectedDateCustom="selectedDateCustom"/>
    </div>
  </div>
</template>

<script>
import TransactionSheet from './TransactionSheet.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState';
export default {
  components: {
    TransactionSheet,
    LoadingState,
  },
  props: {
    payments: {
      type: Array,
      required: true,
    },
    selectedFilters:{
      type: String
    },
    selectedDateCustom:{
      type: Array,
      default: []
    },
  },
  data() {
    return {
      revenueData: [
        { title: 'Total Revenue', amount: 2223.9 },
        { title: 'Sample', amount: 1245.9 },
        { title: 'Development', amount: 947.9 },
        { title: 'Licensing', amount: 912.9 },
        { title: 'Order', amount: 1124.9 },
      ], // Fetched from backend
    };
  },
  computed:{
    graphData() {
      const data = this.$store.getters['payments/graphData'];
      console.log('My Status Data', data);

      // this.$emit('payments-fetched', data); // 👈 emit event to parent
      return data.data;
    },
  },
  methods: {
    isGrater(amount){
       return amount > 100000000
    },
    fetchRevenueData() {
      // Replace with actual API call
      this.revenueData = [
        { title: 'Total Revenue', amount: 2223.9 },
        { title: 'Sample', amount: 1245.9 },
        { title: 'Development', amount: 947.9 },
        { title: 'Licensing', amount: 912.9 },
        { title: 'Order', amount: 1124.9 },
      ];
    },
    truncateAmount(amount) {
      const amountStr = amount.toString();
      return amountStr.length > 11 ? amountStr.slice(0, 8) + '...' : amountStr;
    },
    downloadCSV(value){
      console.log("transaction Sheet",value);
      if(value==true)
      
      this.$emit('download_csv',true)
    }
  },
};
</script>

<style lang="scss" scoped>
.card-style {
  width: 20%;
  border: 2px solid;
  padding: 10px;
  margin:  10px 0px ;
  border-radius: 5px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.card-style-text {
  font-weight: 600;
  padding-bottom: 10px;
}
.card-style-price {
  font-weight: 600;
  font-size: xx-large;
}
.Amount-style{
   font-size: 22px;
}
</style>